// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CasesReportPopup_content_container__8R54Q {
  padding: 20px;
  min-width: 400px;
}

.CasesReportPopup_section__djvvx {
  margin-bottom: 24px;
}

.CasesReportPopup_section_title__HcmRX {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.CasesReportPopup_date_inputs__tzAKG {
  display: flex;
  gap: 16px;
}

.CasesReportPopup_date_input_wrapper__qatzw {
  flex: 1 1;
}

.CasesReportPopup_date_input__ZaQAl {
  width: 100%;
}

.CasesReportPopup_dropdown__w2Y0Q {
  min-width: 200px;
  width: 48.5%;
}

.CasesReportPopup_fields_header__6N18c {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.CasesReportPopup_expand_button__LZB99 {
  padding: 4px;
  color: #666;
}

.CasesReportPopup_expand_button__LZB99:hover {
  background-color: #f5f5f5;
}

.CasesReportPopup_checkboxes_container__B\\+cbt {
  margin-top: 12px;
  padding-left: 8px;
}

.CasesReportPopup_checkbox_row__csCOP {
  display: flex;
  gap: 24px;
  margin-bottom: 8px;
}

.CasesReportPopup_checkbox__eddUI {
  flex: 1 1;
  margin-right: 0;
}

.CasesReportPopup_checkbox__eddUI .CasesReportPopup_MuiFormControlLabel-label__dER9G {
  font-size: 14px;
}

.CasesReportPopup_description__M1\\+gS {
  font-size: 10px !important;
  margin-top: 0px;
  font-style: italic;
}

.CasesReportPopup_btn_cancel__htWYL,
.CasesReportPopup_btn_confirm__B54Nf {
  min-width: 100px;
}

.CasesReportPopup_btn_cancel__htWYL {
  background-color: #f5f5f5;
  color: #666;
}

.CasesReportPopup_btn_confirm__B54Nf {
  background-color: #1976d2;
  color: white;
}

.CasesReportPopup_btn_confirm__B54Nf:hover {
  background-color: #1565c0;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/CasesReportPopup/CasesReportPopup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".content_container {\n  padding: 20px;\n  min-width: 400px;\n}\n\n.section {\n  margin-bottom: 24px;\n}\n\n.section_title {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.date_inputs {\n  display: flex;\n  gap: 16px;\n}\n\n.date_input_wrapper {\n  flex: 1;\n}\n\n.date_input {\n  width: 100%;\n}\n\n.dropdown {\n  min-width: 200px;\n  width: 48.5%;\n}\n\n.fields_header {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.expand_button {\n  padding: 4px;\n  color: #666;\n}\n\n.expand_button:hover {\n  background-color: #f5f5f5;\n}\n\n.checkboxes_container {\n  margin-top: 12px;\n  padding-left: 8px;\n}\n\n.checkbox_row {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 8px;\n}\n\n.checkbox {\n  flex: 1;\n  margin-right: 0;\n}\n\n.checkbox .MuiFormControlLabel-label {\n  font-size: 14px;\n}\n\n.description {\n  font-size: 10px !important;\n  margin-top: 0px;\n  font-style: italic;\n}\n\n.btn_cancel,\n.btn_confirm {\n  min-width: 100px;\n}\n\n.btn_cancel {\n  background-color: #f5f5f5;\n  color: #666;\n}\n\n.btn_confirm {\n  background-color: #1976d2;\n  color: white;\n}\n\n.btn_confirm:hover {\n  background-color: #1565c0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `CasesReportPopup_content_container__8R54Q`,
	"section": `CasesReportPopup_section__djvvx`,
	"section_title": `CasesReportPopup_section_title__HcmRX`,
	"date_inputs": `CasesReportPopup_date_inputs__tzAKG`,
	"date_input_wrapper": `CasesReportPopup_date_input_wrapper__qatzw`,
	"date_input": `CasesReportPopup_date_input__ZaQAl`,
	"dropdown": `CasesReportPopup_dropdown__w2Y0Q`,
	"fields_header": `CasesReportPopup_fields_header__6N18c`,
	"expand_button": `CasesReportPopup_expand_button__LZB99`,
	"checkboxes_container": `CasesReportPopup_checkboxes_container__B+cbt`,
	"checkbox_row": `CasesReportPopup_checkbox_row__csCOP`,
	"checkbox": `CasesReportPopup_checkbox__eddUI`,
	"MuiFormControlLabel-label": `CasesReportPopup_MuiFormControlLabel-label__dER9G`,
	"description": `CasesReportPopup_description__M1+gS`,
	"btn_cancel": `CasesReportPopup_btn_cancel__htWYL`,
	"btn_confirm": `CasesReportPopup_btn_confirm__B54Nf`
};
export default ___CSS_LOADER_EXPORT___;
